export default __webpack_public_path__ + "static/media/Mendocino400.ee370d03.jpg";